// Urgent flag (prompt 53) — an action signal, shown alongside the sentiment
// badge whenever a mention is flagged is_urgent. Marigold pill, dark text.
export default function UrgentBadge() {
  return (
    <span className="badge badge--urgent-flag" title="Urgent — needs immediate attention">
      ⚡ Urgent
    </span>
  );
}
